import React, {Component} from 'react';
import PropTypes from 'prop-types';
import '../assets/stylesheets/Dropdown.scss';

export default class DropTasks extends Component {

    static propTypes = {
        opened: PropTypes.bool,
        selectedItem: PropTypes.string,
        items: PropTypes.any,
        nullOption: PropTypes.string,
        onChange: PropTypes.func,
        index: PropTypes.number
    };

    static defaultProps = {
        opened: false,
        selectedItem: null,
        onChange: () => {},
        nullOption: 'Select Option',
        index: 1
    };

    constructor(props) {
        super(props);

        this.state = {
            opened: props.opened,
            selectedItem: props.selectedItem,
            items: [],
            index: props.index
        }
    }

    componentDidMount() {
        document.addEventListener('click', (e) => { this._closeDropdown(e) }, false);

        const items = this.props.items;
        this.setState({
            items: items.length > 0
                ? [{id: -1, name: this.props.nullOption}, ...items]
                : [{id: -1, name: this.props.nullOption}]
        });
    }

    componentWillUnmount() {
        document.removeEventListener('click', (e) => { this._closeDropdown(e) }, false);
    }

    _closeDropdown(e) {
        if (e.target !== this.dropdown
            && document.querySelectorAll('.dropdown-items').length > 0) {
            this.setState({opened: false});
        }
    }

    componentWillReceiveProps(props) {
        this.setState({
            items: props.items.length > 0
                ? [{id: -1, name: props.nullOption}, ...props.items]
                : [{id: -1, name: props.nullOption}]
        });

        if (props.items.length === 0 || props.items !== this.props.items) {
            this.setState({
                selectedItem: this.props.nullOption
            })
        }
    }

    handleClick(item) {
        this.setState((prevState, props) => {
            return {
            opened: !prevState.opened,
            selectedItem: item ? (item.name || item.activity) : this.props.nullOption
        }});

        this.props.onChange(item);
    }

    handleOpen() {
        this.setState(prevState => ({opened: !prevState.opened}));
    }

    render() {

        const itemsEl = this.state.items.map(
            (item, index) => {
                return <li key={index} onClick={this.handleClick.bind(this, item)}>{item.name || item.activity}</li>
            }
        );

        return (
            <div className="Dropdown">
                <label className="label-task">Task {this.state.index+1}</label>
                <div className="dropdown-selected" ref={ref => this.dropdown = ref}
                     onClick={this.handleOpen.bind(this)}>{this.state.selectedItem}</div>
                <div className={"dropdown-items" + (this.state.opened ? " opened" : "")}>
                    <ul>
                        <li key={-1} onClick={this.handleClick.bind(this, -1)}>{this.state.nullOption}</li>
                        {itemsEl}
                    </ul>
                </div>
            </div>

        )
    }

}


// WEBPACK FOOTER //
// ./src/components/DropTasks.js